var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "slide-from-left" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$store.state.ui.paintCalculatorIsOpen,
                expression: "$store.state.ui.paintCalculatorIsOpen",
              },
            ],
            staticClass: "fixed left-0 inset-y-0 w-full max-w-lg bg-white z-80",
          },
          [
            _c("div", { staticClass: "flex flex-col h-full" }, [
              _c(
                "div",
                { staticClass: "px-5 py-5 sm:py-6 border-b bg-white" },
                [
                  _c("div", { staticClass: "grid grid-cols-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "col-span-1 link",
                        on: {
                          click: function ($event) {
                            return _vm.$store.commit("closePaintCalculator")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "w-5 h-5" },
                          [_c("IconCross")],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h3",
                      {
                        staticClass:
                          "col-span-4 text-md sm:text-lg text-center",
                      },
                      [_vm._v("\n              Paint Calculator\n            ")]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasError(),
                      expression: "hasError()",
                    },
                  ],
                  staticClass:
                    "px-6 py-2 bg-red text-white font-semibold -mt-px",
                  attrs: { role: "alert" },
                },
                [
                  _vm._v(
                    "\n          Please ensure all input is valid\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "flex-1 h-full overflow-y-auto scrolling-touch",
                  attrs: { novalidate: "" },
                },
                [
                  _c("div", { staticClass: "h-full flex flex-col" }, [
                    _c(
                      "div",
                      { staticClass: "flex-1 px-2 sm:px-6 pb-6" },
                      [
                        _c("fieldset", { staticClass: "py-6" }, [
                          _c("legend", { staticClass: "sr-only" }, [
                            _vm._v("Job Type"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "grid grid-cols-2 gap-3 sm:gap-6" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-span-2 sm:col-span-1" },
                                [
                                  _c("Toggle", {
                                    attrs: {
                                      id: "coating-is-new-job",
                                      labels: ["New Job", "Re-paint"],
                                    },
                                    model: {
                                      value: _vm.isNewJob,
                                      callback: function ($$v) {
                                        _vm.isNewJob = $$v
                                      },
                                      expression: "isNewJob",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-span-2 sm:col-span-1" },
                                [
                                  _c("Toggle", {
                                    attrs: {
                                      id: "paint-is-interior",
                                      labels: ["Interior", "Exterior"],
                                    },
                                    model: {
                                      value: _vm.isInterior,
                                      callback: function ($$v) {
                                        _vm.isInterior = $$v
                                      },
                                      expression: "isInterior",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isInterior
                          ? _c("InteriorAreaAccordion", {
                              attrs: { value: _vm.interiorAreas },
                              on: {
                                input: (payload) =>
                                  (_vm.interiorAreas = payload),
                              },
                            })
                          : _c("ExteriorAreaAccordion", {
                              attrs: { value: _vm.exteriorAreas },
                              on: {
                                input: (payload) =>
                                  (_vm.exteriorAreas = payload),
                              },
                            }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.hasError(),
                            expression: "!hasError()",
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "bg-grey py-7 px-2 sm:px-6" },
                          [
                            _c(
                              "h3",
                              { staticClass: "text-md mb-4 flex items-center" },
                              [
                                _vm._v(
                                  "\n                  Recommended Products\n                  "
                                ),
                                _c("ButtonInfo", {
                                  staticClass: "ml-2",
                                  attrs: {
                                    heading: "",
                                    body: "All of the paints you need to get a perfectly finished project",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isInterior
                              ? _c("InteriorResultsPanel", {
                                  attrs: {
                                    quantities: _vm.interiorQuantities,
                                    "is-new-job": _vm.isNewJob,
                                  },
                                })
                              : _c("ExteriorResultsPanel", {
                                  attrs: {
                                    quantities: _vm.exteriorQuantities,
                                    "is-new-job": _vm.isNewJob,
                                  },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-wrap justify-between border-t py-5 px-2 sm:px-6 bg-paint",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "w-full sm:w-auto sm:text-md font-semibold mb-1 sm:mb-0 text-theme",
                                },
                                [
                                  _vm._v(
                                    "\n                    You need " +
                                      _vm._s(
                                        _vm._f("formatVolume")(
                                          _vm.totalQuantity
                                        )
                                      ) +
                                      " total\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "link underline text-left text-theme",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.isSendFormOpen = !_vm.isSendFormOpen
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Email me this info\n                  "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c(
            "Modal",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isSendFormOpen,
                  expression: "isSendFormOpen",
                },
              ],
              on: {
                close: function ($event) {
                  _vm.isSendFormOpen = false
                },
              },
            },
            [
              _c("PaintCalculatorEmailForm", {
                attrs: {
                  interior: _vm.isInterior,
                  "new-job": _vm.isNewJob,
                  quantities: _vm.isInterior
                    ? _vm.interiorQuantities
                    : _vm.exteriorQuantities,
                },
                on: {
                  close: function ($event) {
                    return _vm.handleEmailFormSubmit()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }